<template>
  <ul class="a-list-element-actions position-right">
    <li>
      <router-link
        :class="`a-tooltip-primary a-tooltip-left text-color-first-action`"
        :data-tooltip-text="$t('aListElementActionsPrimary.tooltipEdit')"
        href="#"
        :to="editionRoute"
      >
        <i class="far fa-pencil-alt"></i>
      </router-link>
    </li>
    <li>
      <a
        :class="`a-tooltip-primary a-tooltip-left text-color-second-action`"
        :data-tooltip-text="$t('aListElementActionsPrimary.tooltipDuplicate')"
        href="/duplicar"
        @click.prevent="$modal.showModal(modalBodyDuplicate, modalElementDuplicate)"
      >
        <i class="far fa-copy"></i>
      </a>
    </li>
    <li>
      <a
        class="a-tooltip-primary a-tooltip-left text-color-fourth-action"
        :data-tooltip-text="$t('aListElementActionsPrimary.tooltipDelete')"
        href="/eliminar"
        @click.prevent="$modal.showModal(modalBodyDelete, element)"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AtomListElementActionsPrimary',

  props: {
    element: Object,
    position: String
  },

  computed: {
    editionRoute () {
      if (this.$route.name === 'products') {
        return `/${this.$t('rPaths.product')}/${this.element.id}/${this.$t('mEditionMenu.product.card.subject')}`
      } else if (this.$route.name === 'projects') {
        if (this.element.tipo === 1) {
          return `/${this.$t('rPaths.map')}/${this.element.id}/${this.$t('mEditionMenu.map.card.subject')}`
        } else {
          return `/${this.$t('rPaths.asset')}/${this.element.id}/${this.$t('mEditionMenu.asset.card.subject')}`
        }
      }
      return null
    },

    modalBodyDelete () {
      if (this.$route.name === 'products') {
        return 'MoleculeFeedProductsContentModalDelete'
      } else if (this.$route.name === 'projects') {
        if (this.element.tipo === 1) {
          return 'MoleculeFeedMapsContentModalDelete'
        } else {
          return 'MoleculeFeedAssetsContentModalDelete'
        }
      }
      return null
    },

    modalBodyDuplicate () {
      if (this.$route.name === 'products') {
        return this.$license.isMaximumReached('productos')
          ? 'MoleculeLicenseModalUpgrade'
          : 'MoleculeFeedProductsContentModalDuplicate'
      } else if (this.$route.name === 'projects') {
        if (this.element.tipo === 1) {
          return this.$license.isMaximumReached('mapas')
            ? 'MoleculeLicenseModalUpgrade'
            : 'MoleculeFeedMapsContentModalDuplicate'
        } else {
          return this.$license.isMaximumReached('proyectos')
            ? 'MoleculeLicenseModalUpgrade'
            : 'MoleculeFeedAssetsContentModalDuplicate'
        }
      }
      return null
    },

    modalElementDuplicate () {
      if (this.$route.name === 'products') {
        return this.$license.isMaximumReached('productos')
          ? 'productos'
          : this.element
      } else if (this.$route.name === 'projects') {
        if (this.element.tipo === 1) {
          return this.$license.isMaximumReached('mapas')
            ? 'mapas'
            : this.element
        } else {
          return this.$license.isMaximumReached('proyectos')
            ? 'cursos'
            : this.element
        }
      }
      return null
    }
  }
}
</script>
